<div class="content">
  <h1>Add Task</h1>
  <form #newTaskForm="ngForm" (keydown.enter)="$event.preventDefault()">
    <div class="form-input">
      <div class="form-input-left">
        <!-- #region TITLE -->
        <div class="input-wrapper">
          <h6>Title<span class="red">*</span></h6>
          <input #title="ngModel" class="form-field" maxlength="30" type="text" name="title" [(ngModel)]="newTask.title" (ngModelChange)="saveInputs()"
            placeholder="Enter a title" pattern=".*[A-Za-zÄÖÜäöüß].*" required />
          @if(!title.valid && title.touched){
          <span class="warning">This field is required!</span>
          } @if(titleTooLong){
          <span class="warning">Title must not exceed 30 characters.</span>
          }
        </div>
        <!-- #endregion -->
        <!-- #region DESCRIPTION -->
        <div class="input-wrapper">
          <h6>Description</h6>
          <textarea maxlength="500" name="description" id="" [(ngModel)]="newTask.description" (ngModelChange)="saveInputs()"
            placeholder="Enter a description"></textarea>
        </div>
        <!-- #endregion -->
        <!-- #region DUE DATE -->
        <div class="input-wrapper">
          <h6>Due date<span class="red">*</span></h6>
          <app-date-picker [selectedDate]="newTask.date" (sendDate)="setDate($event)"></app-date-picker>
        </div>
        <!-- #endregion -->
      </div>
      <div class="dividing-line"></div>
      <div class="form-input-right">
        <!-- #region PRIORITY -->
        <div class="input-wrapper">
          <h6>Priority</h6>
          <div class="priority-btn-wrapper">
            <button type="button" (click)="setPriorityUrgent()" [ngClass]="{ 'active-urgent': priorityFlag.urgent }">
              Urgent
              <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379835_5802)">
                  <path
                    d="M19.6528 15.2547C19.4182 15.2551 19.1896 15.1803 19.0007 15.0412L10.7487 8.958L2.49663 15.0412C2.38078 15.1267 2.24919 15.1887 2.10939 15.2234C1.96959 15.2582 1.82431 15.2651 1.68184 15.2437C1.53937 15.2223 1.40251 15.1732 1.27906 15.099C1.15562 15.0247 1.04801 14.927 0.96238 14.8112C0.876751 14.6954 0.814779 14.5639 0.780002 14.4243C0.745226 14.2846 0.738325 14.1394 0.759696 13.997C0.802855 13.7095 0.958545 13.4509 1.19252 13.2781L10.0966 6.70761C10.2853 6.56802 10.5139 6.49268 10.7487 6.49268C10.9835 6.49268 11.212 6.56802 11.4007 6.70761L20.3048 13.2781C20.4908 13.415 20.6286 13.6071 20.6988 13.827C20.7689 14.0469 20.7678 14.2833 20.6955 14.5025C20.6232 14.7216 20.4834 14.9124 20.2962 15.0475C20.1089 15.1826 19.8837 15.2551 19.6528 15.2547Z"
                    fill="#FF3D00" />
                  <path
                    d="M19.6528 9.50568C19.4182 9.50609 19.1896 9.43124 19.0007 9.29214L10.7487 3.20898L2.49663 9.29214C2.26266 9.46495 1.96957 9.5378 1.68184 9.49468C1.39412 9.45155 1.13532 9.29597 0.962385 9.06218C0.789449 8.82838 0.716541 8.53551 0.7597 8.24799C0.802859 7.96048 0.95855 7.70187 1.19252 7.52906L10.0966 0.958588C10.2853 0.818997 10.5139 0.743652 10.7487 0.743652C10.9835 0.743652 11.212 0.818997 11.4007 0.958588L20.3048 7.52906C20.4908 7.66598 20.6286 7.85809 20.6988 8.07797C20.769 8.29785 20.7678 8.53426 20.6955 8.75344C20.6232 8.97262 20.4834 9.16338 20.2962 9.29847C20.1089 9.43356 19.8837 9.50608 19.6528 9.50568Z"
                    fill="#FF3D00" />
                </g>
                <defs>
                  <clipPath id="clip0_379835_5802">
                    <rect width="20" height="14.5098" fill="white" transform="translate(0.748535 0.745117)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button type="button" (click)="setPriorityMedium()" [ngClass]="{ 'active-medium': priorityFlag.medium }">
              Medium
              <svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_379835_5809)">
                  <path
                    d="M19.1526 7.72528H1.34443C1.05378 7.72528 0.775033 7.60898 0.569514 7.40197C0.363995 7.19495 0.248535 6.91419 0.248535 6.62143C0.248535 6.32867 0.363995 6.0479 0.569514 5.84089C0.775033 5.63388 1.05378 5.51758 1.34443 5.51758H19.1526C19.4433 5.51758 19.722 5.63388 19.9276 5.84089C20.1331 6.0479 20.2485 6.32867 20.2485 6.62143C20.2485 6.91419 20.1331 7.19495 19.9276 7.40197C19.722 7.60898 19.4433 7.72528 19.1526 7.72528Z"
                    fill="#FFA800" />
                  <path
                    d="M19.1526 2.48211H1.34443C1.05378 2.48211 0.775033 2.36581 0.569514 2.1588C0.363995 1.95179 0.248535 1.67102 0.248535 1.37826C0.248535 1.0855 0.363995 0.804736 0.569514 0.597724C0.775033 0.390712 1.05378 0.274414 1.34443 0.274414L19.1526 0.274414C19.4433 0.274414 19.722 0.390712 19.9276 0.597724C20.1331 0.804736 20.2485 1.0855 20.2485 1.37826C20.2485 1.67102 20.1331 1.95179 19.9276 2.1588C19.722 2.36581 19.4433 2.48211 19.1526 2.48211Z"
                    fill="#FFA800" />
                </g>
                <defs>
                  <clipPath id="clip0_379835_5809">
                    <rect width="20" height="7.45098" fill="white" transform="translate(0.248535 0.274414)" />
                  </clipPath>
                </defs>
              </svg>
            </button>
            <button type="button" (click)="setPriorityLow()" [ngClass]="{ 'active-low': priorityFlag.low }">
              Low
              <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.2485 9.50589C10.0139 9.5063 9.7854 9.43145 9.59655 9.29238L0.693448 2.72264C0.57761 2.63708 0.47977 2.52957 0.405515 2.40623C0.33126 2.28289 0.282043 2.14614 0.260675 2.00379C0.217521 1.71631 0.290421 1.42347 0.463337 1.1897C0.636253 0.955928 0.895022 0.800371 1.18272 0.757248C1.47041 0.714126 1.76347 0.786972 1.99741 0.95976L10.2485 7.04224L18.4997 0.95976C18.6155 0.874204 18.7471 0.812285 18.8869 0.777538C19.0266 0.742791 19.1719 0.735896 19.3144 0.757248C19.4568 0.7786 19.5937 0.82778 19.7171 0.901981C19.8405 0.976181 19.9481 1.07395 20.0337 1.1897C20.1194 1.30545 20.1813 1.43692 20.2161 1.57661C20.2509 1.71629 20.2578 1.86145 20.2364 2.00379C20.215 2.14614 20.1658 2.28289 20.0916 2.40623C20.0173 2.52957 19.9195 2.63708 19.8036 2.72264L10.9005 9.29238C10.7117 9.43145 10.4831 9.5063 10.2485 9.50589Z"
                  fill="#7AE229" />
                <path
                  d="M10.2485 15.2544C10.0139 15.2548 9.7854 15.18 9.59655 15.0409L0.693448 8.47117C0.459502 8.29839 0.30383 8.03981 0.260675 7.75233C0.217521 7.46485 0.290421 7.17201 0.463337 6.93824C0.636253 6.70446 0.895021 6.54891 1.18272 6.50578C1.47041 6.46266 1.76347 6.53551 1.99741 6.7083L10.2485 12.7908L18.4997 6.7083C18.7336 6.53551 19.0267 6.46266 19.3144 6.50578C19.602 6.54891 19.8608 6.70446 20.0337 6.93824C20.2066 7.17201 20.2795 7.46485 20.2364 7.75233C20.1932 8.03981 20.0376 8.29839 19.8036 8.47117L10.9005 15.0409C10.7117 15.18 10.4831 15.2548 10.2485 15.2544Z"
                  fill="#7AE229" />
              </svg>
            </button>
          </div>
        </div>
        <!-- #endregion -->
        <!-- #region ASSIGNED TO -->
        <div class="input-wrapper" id="rp-wrapper">
          <h6>Assigned to</h6>
          <app-rp-search (sendContact)="addRpToArray($event)" [selectedContacts]="newTask.assignedTo" (contactsChanged)="updateAssignedContacts($event)">
          </app-rp-search>
          <div [ngClass]="{'rp-selected-box': newTask.assignedTo.length >= 1}">
            @if (newTask.assignedTo.length > 3) { @for (contact of getThreeRP();
            track $index){
            <span class="initials" [style.backgroundColor]="contact.bgColor">
              {{ getLetters(contact) }}
            </span>
            }
            <span>+ {{ valueRp() }}</span>
            } @else { @for (contact of newTask.assignedTo; track $index){
            <span class="initials" [style.backgroundColor]="contact.bgColor">
              {{ getLetters(contact) }}
            </span>
            } }
          </div>
        </div>
        <!-- #region CATEGORY -->
        <div class="input-wrapper">
          <h6>Category<span class="red">*</span></h6>
          <app-category (sendCategory)="setCategory($event)" [value]="newTask.category"></app-category>
          @if(categorySelected === false){
          <span class="warning">This field is required!</span>
          }
        </div>
        <!-- #endregion -->
        <!-- #region SUBTASKS -->
        <div class="input-wrapper" id="subtask-wrapper">
          <h6>Subtasks</h6>
          <div class="subtask-input-wrapper">
            <input #subtask="ngModel" class="form-field" id="subtask-input" type="text" maxlength="150" [(ngModel)]="singleSubtask" (ngModelChange)="saveInputs()"
              name="subtask" placeholder="Add new subtask" appPatternValidator="generalText" (keydown.enter)="addSubtask(subtask)" />
            <div class="subtask-btn-wrapper">
              <button (click)="clearSubtaskInput()" type="button" class="clear-btn" ></button>
              <div class="btn-divide"></div>
              <button type="button" class="add-btn" (click)="addSubtask(subtask)"></button>
            </div>
          </div>
          <ul [ngClass]="{'hidden' : newTask.subtasks.length == 0}">
            <li *ngFor="let s of newTask.subtasks; let i = index" [class.editing]="isEditing(i)">
              <div class="list-content">
                <span *ngIf="!isEditing(i)">{{ s.title }}</span>
                <!-- #region EDIT SUBTASKS -->
                <div class="edit-wrapper">
                  <input *ngIf="isEditing(i)" type="text" class="edit-input" [(ngModel)]="s.title"
                    name="subtaskTitle{{ i }}" (keydown.enter)="saveSubtaskEdit(i)" (blur)="saveSubtaskEdit(i)" />

                  <!-- #region EDIT-SUBTASK-BTNS -->
                  <div class="edit-subtask" [class.force-visible]="isEditing(i)">
                    <!-- #region EDIT SUBTASK MODE -->
                    <button *ngIf="isEditing(i)" class="check-btn" type="button" (click)="saveSubtaskEdit(i)">
                      <svg width="22" height="22" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M9.79923 15.15L18.2742 6.675C18.4742 6.475 18.7117 6.375 18.9867 6.375C19.2617 6.375 19.4992 6.475 19.6992 6.675C19.8992 6.875 19.9992 7.1125 19.9992 7.3875C19.9992 7.6625 19.8992 7.9 19.6992 8.1L10.4992 17.3C10.2992 17.5 10.0659 17.6 9.79923 17.6C9.53256 17.6 9.29923 17.5 9.09923 17.3L4.79923 13C4.59923 12.8 4.5034 12.5625 4.51173 12.2875C4.52006 12.0125 4.62423 11.775 4.82423 11.575C5.02423 11.375 5.26173 11.275 5.53673 11.275C5.81173 11.275 6.04923 11.375 6.24923 11.575L9.79923 15.15Z"
                            fill="#2A3647" />
                        </g>
                      </svg>
                    </button>
                    <!-- #endregion -->
                    <button *ngIf="!isEditing(i)" class="edit-btn" type="button" (click)="editSubtask(i)">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M5 19H6.4L15.025 10.375L13.625 8.975L5 17.6V19ZM19.3 8.925L15.05 4.725L16.45 3.325C16.8333 2.94167 17.3042 2.75 17.8625 2.75C18.4208 2.75 18.8917 2.94167 19.275 3.325L20.675 4.725C21.0583 5.10833 21.2583 5.57083 21.275 6.1125C21.2917 6.65417 21.1083 7.11667 20.725 7.5L19.3 8.925ZM17.85 10.4L7.25 21H3V16.75L13.6 6.15L17.85 10.4Z"
                            fill="#2A3647" />
                        </g>
                      </svg>
                    </button>
                    <div class="separator"></div>
                    <button class="delete-btn" type="button" (click)="deleteSubtask(i)">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor"
                        xmlns="http://www.w3.org/2000/svg">
                        <g>
                          <path
                            d="M7 21C6.45 21 5.97917 20.8042 5.5875 20.4125C5.19583 20.0208 5 19.55 5 19V6C4.71667 6 4.47917 5.90417 4.2875 5.7125C4.09583 5.52083 4 5.28333 4 5C4 4.71667 4.09583 4.47917 4.2875 4.2875C4.47917 4.09583 4.71667 4 5 4H9C9 3.71667 9.09583 3.47917 9.2875 3.2875C9.47917 3.09583 9.71667 3 10 3H14C14.2833 3 14.5208 3.09583 14.7125 3.2875C14.9042 3.47917 15 3.71667 15 4H19C19.2833 4 19.5208 4.09583 19.7125 4.2875C19.9042 4.47917 20 4.71667 20 5C20 5.28333 19.9042 5.52083 19.7125 5.7125C19.5208 5.90417 19.2833 6 19 6V19C19 19.55 18.8042 20.0208 18.4125 20.4125C18.0208 20.8042 17.55 21 17 21H7ZM7 6V19H17V6H7ZM9 16C9 16.2833 9.09583 16.5208 9.2875 16.7125C9.47917 16.9042 9.71667 17 10 17C10.2833 17 10.5208 16.9042 10.7125 16.7125C10.9042 16.5208 11 16.2833 11 16V9C11 8.71667 10.9042 8.47917 10.7125 8.2875C10.5208 8.09583 10.2833 8 10 8C9.71667 8 9.47917 8.09583 9.2875 8.2875C9.09583 8.47917 9 8.71667 9 9V16ZM13 16C13 16.2833 13.0958 16.5208 13.2875 16.7125C13.4792 16.9042 13.7167 17 14 17C14.2833 17 14.5208 16.9042 14.7125 16.7125C14.9042 16.5208 15 16.2833 15 16V9C15 8.71667 14.9042 8.47917 14.7125 8.2875C14.5208 8.09583 14.2833 8 14 8C13.7167 8 13.4792 8.09583 13.2875 8.2875C13.0958 8.47917 13 8.71667 13 9V16Z"
                            fill="#2A3647" />
                        </g>
                      </svg>
                    </button>
                  </div>
                  <!-- #endregion -->
                </div>
              </div>
            </li>
          </ul>
          <span
            *ngIf="newTask.subtasks.length === 0 && showInvalidSubtaskWarning"
            class="warning">
              {{invalidSubtaskMessage}}
          </span>
          <span
            *ngIf="newTask.subtasks.length > 0 && showInvalidSubtaskWarning"
            class="warning-invalid-subtask">
            {{invalidSubtaskMessage}}
          </span>
        </div>
      </div>
    </div>
    <!-- #region FORM BUTTONS -->
    <div class="form-submit">
      <span><span class="red">*</span>This field is required.</span>
      <div class="btn-wrapper">
        <button type="button" class="cancel-btn" (click)="onClearInputs(title)">
          Clear
          <svg class="cancel-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path d="M6 6L18 18M6 18L18 6" />
          </svg>
        </button>
        <div class="submit-wrapper">
          <input type="submit" value="Create task" (click)="sendForm(newTaskForm, title)"/>
          <img src="assets/icons/check.svg" alt="check-img" />
        </div>
      </div>
    </div>
  </form>
</div>
<div [ngClass]="{'load-overlay': isLoading}"></div>
